var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nx-dialog',{attrs:{"visible":_vm.show,"title":{ add: '新增', edit: '编辑', detail: '详情' }[_vm.type],"width":"750px","before-close":_vm.beforeClose},on:{"update:visible":function($event){_vm.show=$event},"onConfirm":_vm.onConfirm}},[_c('nx-form',{ref:"submitForm",attrs:{"source":_vm.submitForm,"config":_vm.submitConfig}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }